import { Image } from 'react-bootstrap'
import CarPlaceholder from '../../assets/images/workflow/cartest.svg'
import { getVehicleImageInfo } from '../../utils/vehicleSummary'
import './vehicleSummary.scss'

// Vehicle Info cell shared by the ADAS report, estimate and invoice lists.
// Markup and styles are a copy of the admin portal's commons/VehicleInfo (Bootstrap 5
// spacing classes instead of 4), so the two portals render the cell the same way.
const VehicleSummary = ({ vehicle, extraCount = 0, className = '' }) => {
  if (!vehicle) return '—'
  const { year, make, model, color, vin, stock, image } = vehicle
  const carInfo = `${make || ''} ${model || ''}`.trim()
  const { url, isS3, isPlaceholder } = getVehicleImageInfo(image)
  const imageClass = `image-vehicle${isS3 ? ' image-vehicle--s3' : ''}${isPlaceholder ? ' image-vehicle--placeholder' : ''}`

  return (
    <div className={`list-vehicle-info position-relative ${className}`.trim()}>
      <div className='d-flex justify-content-center py-2'>
        <div className='image-vehicle-container'>
          <Image src={isPlaceholder ? CarPlaceholder : url} className={imageClass} />
        </div>

        <div className='vehicle-info flex-grow-1 ms-2'>
          {(carInfo || year || color) && (
            <p className='mb-0 vehicle-title'>
              {year ? <span className='me-2 year-vehicle'>{year}</span> : ''}
              {carInfo ? <strong className='mx-1'>{carInfo}</strong> : ''}
              {color ? <span className='ms-2 color-vehicle'>{color}</span> : ''}
            </p>
          )}
          <div className='mb-0'>
            <strong>STOCK/RO:</strong>
            {` ${stock || 'Not listed'}`}
          </div>
          <div className='mb-0'>
            <strong>VIN:</strong>
            {` ${vin || 'Not listed'}`}
          </div>
          {extraCount > 0 && <div className='text-primary btn-more'>{`+${extraCount}More`}</div>}
        </div>
      </div>
    </div>
  )
}


export default VehicleSummary
